import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import ErrorBoundary from "components/Layout/ErrorBoundary";

import { Row, Nav, Tab, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Icon from "components/Icons/Icon";

import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";
import { loadSiteSchedulesStart } from "services/redux/actions/singleSites";

import CoreSchedule from "./CoreSchedule.js";
import Overrides from "./Overrides.js";
import AddRule from "./AddRule.js";

import { parseHHmmTime } from "utils/date";

import { withT } from "services/translation/";

const TabOptions = [
  {
    key: "core_schedule",
    col: 4,
    Component: CoreSchedule,
  },
  {
    key: "overrides",
    col: 4,
    Component: Overrides,
  },
];

const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

function Schedules({ t, site, onBackToOverview, setShowFooter}) {
  const dispatch = useDispatch();

  const enterprise = useSelector(getEnterpriseFromRoute);

  const [key, setKey] = useState("core_schedule");

  useEffect(() => {
    dispatch(loadSiteSchedulesStart({
      sudo_site_id: site.sudo_site_id,
      enterprise_id: enterprise ? enterprise.id : null,
    }))
  }, [site.sudo_site_id]);

  useEffect(() => {
    setShowFooter(true); // set the initial state of the footer as true because we open on the core tab
  }, []);

  const getFormattedIdealAndOffsets = (ideal, early, late) => {
    const idealEventHour = ideal || "00:00";
    let earlyOffsetTime = idealEventHour;
    let earlyOffsetMinutes = 0;
    let lateOffsetTime = idealEventHour;
    let lateOffsetMinutes = 0;

    const { hours, minutes } = parseHHmmTime(idealEventHour);
    const idealTimeInMiutes = (hours*60) + minutes;

    if (early && !isNaN(early)) {
      earlyOffsetMinutes = Number(early);

      const earlyOffsetTimeInMinutes = idealTimeInMiutes - Number(early);
      if (earlyOffsetTimeInMinutes > 0) {
        earlyOffsetTime = String(Math.floor(earlyOffsetTimeInMinutes/60)).padStart(2, "0") + ":" + String(earlyOffsetTimeInMinutes%60).padStart(2, "0");
      } else {
        earlyOffsetTime = "00:00";
      }
    }
    if (late && !isNaN(late)) {
      lateOffsetMinutes = Number(late);

      const lateOffsetTimeInMinutes = idealTimeInMiutes + Number(late);
      if (lateOffsetTimeInMinutes < 1439) {
        lateOffsetTime = String(Math.floor(lateOffsetTimeInMinutes/60)).padStart(2, "0") + ":" + String(lateOffsetTimeInMinutes%60).padStart(2, "0");
      } else {
        lateOffsetTime = "23:59";
      }
    }

    return {
      idealEventHour,
      idealTimeInMiutes,
      earlyOffsetTime,
      earlyOffsetMinutes,
      lateOffsetTime,
      lateOffsetMinutes,
    }
  }

  return (
    <>
      <Row className="px-2 mt-2 mb-3">
        <div className="btn btn-default border-none side-pane-back text-dark">
          <Link to="#" onClick={onBackToOverview}>
            <span className="back-to-overview"><Icon className="fas fa-chevron-left mr-2" /> {t("back_to_overview")}</span>
          </Link>
        </div>
      </Row>
      <Row>
        <Col>
          <h4 className="mt-0 pb-2 header-title">
            <Icon className="far fa-clock pr-1" />
            {t("title")}
          </h4>
        </Col>
      </Row>

      <Tab.Container
        activeKey={key}
        onSelect={(key) => {
          setKey(key);
          if (key === "core_schedule") {
            setShowFooter(true);
          } else {
            setShowFooter(false);
          }
        }}
      >
        <Row className="m-0">
          <Col className="p-0">
            <Nav variant="pills" className="row px-2">
              {TabOptions.map(({ key, col }, index) => (
                <Nav.Item className={"col-" + col} key={index}>
                  <Nav.Link eventKey={key} className="text-center text-nowrap">
                    {t("tabs." + key)}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          {key === "overrides" && <Col xs="1" className="p-0">
              <AddRule
                site={site}
                enterprise_id={enterprise ? enterprise.id : null}
                weekdays={weekdays}
                getFormattedIdealAndOffsets={getFormattedIdealAndOffsets}
              />
          </Col>}
        </Row>

        <Row>
          <Col>
            <Tab.Content>
              {TabOptions.map((tabOption, index) => {
                const Component = tabOption.Component
                const active = key === tabOption.key;
                return active ? (
                  <Tab.Pane key={index} eventKey={tabOption.key} className="pt-3">
                    <ErrorBoundary message="Error: couldn't load site data">
                      <Component
                        site={site}
                        enterprise_id={enterprise ? enterprise.id : null}
                        weekdays={weekdays}
                        getFormattedIdealAndOffsets={getFormattedIdealAndOffsets}
                      />
                    </ErrorBoundary>
                  </Tab.Pane>
                ) : null;
              })}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </>
  );
}

export default withT(
  Schedules,
  "site_overview.side_pane.schedules"
);